<template>
	<div id="app">
		<div id="content">
			<div class="d-block d-md-none btn-mobile-menu" @click="showMenu" :class="show == true ? 'show' : ''">
				<img src="/assets/sidebar/icon-menu.png">
			</div>
			<ml-sidebar @action="toggleShow" @hover="triggerHide" :class="show == true ? 'show' : ''"></ml-sidebar>
			<!-- <div class="trigger-hide" @click="triggerHide">isa</div> -->
			<router-view :class="hide == true ? 'wide' : ''" />
		</div>
		<vue-progress-bar />
	</div>
</template>

<script>
export default {
	name: 'Main',
	data() {
		return {
			hide: true,
			show: false,
			navMobile: false,
		}
	},
	methods: {
		triggerHide() {
			if ( !this.hide ) {
				this.hide = true
			} else {
				this.hide = false
			}
		},
		showMenu() {
			if ( !this.show ) {
				this.show = true
			} else {
				this.show = false
			}
		},
		toggleShow(val) {
			this.show = val
		},
	}
};
</script>

<style>
.trigger-hide {
	position: absolute;
	z-index: 1;

	left: 50%;
}
</style>
